import Title from "../components/Title";

const projects = [
  {
    title: "Yakamoz Find & Belong",
    link: "https://getyakamoz.com",
    desc: "A directory app with a community feed for the Turkish community across Australia, built using React Native, Python and MongoDB.",
  },
];

const modules = [
  {
    title: "tiktok-pixel",
    link: "https://www.npmjs.com/package/tiktok-pixel",
    desc: "React wrapper for the TikTok pixel for analytics reporting",
  },
  {
    title: "react-formik-stepper",
    link: "https://www.npmjs.com/package/react-formik-stepper",
    desc: "A flexible multistep wizard built for React and Formik",
  },
];

const Projects = () => {
  return (
    <div>
      <section className="section">
        <Title title="Npm modules" />
        {modules.map((module) => (
          <div key={module.title} className="entry">
            <a
              className="entry-link"
              href={module.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {module.title} ↗
            </a>
            <p className="entry-desc">{module.desc}</p>
          </div>
        ))}
      </section>

      <section className="section">
        <Title title="Projects" />
        {projects.map((project) => (
          <div key={project.title} className="entry">
            <a
              className="entry-link"
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {project.title} ↗
            </a>
            <p className="entry-desc">{project.desc}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Projects;
